import { parameterFormParameterSchema } from "@/lib/schema/configuration/parameter";
import { FullConfiguration } from "@/types/crm/configuration/configuration";
import { z } from "zod";

export const parameterFormSchema: z.ZodType<FullConfiguration> = z.object({
    parameter: z.object({
        crm: z.array(parameterFormParameterSchema).optional(),
        project: z.array(parameterFormParameterSchema).optional(),
        survey: z.array(parameterFormParameterSchema).optional(),
        question: z.array(parameterFormParameterSchema).optional(),
    })
});

